import { render, staticRenderFns } from "./footer-subscription.vue?vue&type=template&id=2fe694e9&scoped=true"
import script from "./footer-subscription.vue?vue&type=script&lang=js"
export * from "./footer-subscription.vue?vue&type=script&lang=js"
import style0 from "./footer-subscription.vue?vue&type=style&index=0&id=2fe694e9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe694e9",
  null
  
)

export default component.exports